import { Link } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout.tsx';

interface Wireframe {
  title: string
  description: string
  path: string
  status: string
}

interface Props {
  wireframes: Wireframe[]
}

const statusStyles: Record<string, string> = {
  draft: 'bg-slate-100 text-slate-600',
  review: 'bg-amber-100 text-amber-700',
  approved: 'bg-emerald-100 text-emerald-700',
}

export default function Index({ wireframes }: Props) {
  return (
    <AppLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Wireframes</h1>
          <p className="text-muted-foreground mt-1">Prototype designs for review and iteration.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {wireframes.map((wf) => (
            <Link
              key={wf.path}
              href={wf.path}
              className="block rounded-xl border bg-card p-5 hover:shadow-md transition-shadow"
            >
              <div className="flex items-start justify-between gap-3 mb-3">
                <h2 className="text-base font-semibold text-card-foreground leading-snug">{wf.title}</h2>
                <span className={`shrink-0 inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusStyles[wf.status] ?? statusStyles.draft}`}>
                  {wf.status}
                </span>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">{wf.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </AppLayout>
  )
}
